import { GET_COUPONS } from "./constants";

const init = {
  coupons: {},
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const couponsReducer = (state = init, action) => {
  // eslint-disable-next-line sonarjs/no-small-switch
  switch (action.type) {
    case GET_COUPONS: {
      return {
        ...state,
        coupons: action.payload.data,
      };
    }
    default:
      return state;
  }
};
export default couponsReducer;
